import React from 'react'
import {Icon} from '@chakra-ui/react'

const SearchIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" id="search" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.0404 14.6071C18.2669 13.069 19 11.1201 19 9C19 4.02944 14.9706 0 10 0C5.02944 0 1 4.02944 1 9C1 13.9706 5.02944 18 10 18C12.1201 18 14.069 17.2669 15.6071 16.0404L22.5667 23L24 21.5667L17.0404 14.6071ZM10 16C6.13401 16 3 12.866 3 9C3 5.13401 6.13401 2 10 2C13.866 2 17 5.13401 17 9C17 12.866 13.866 16 10 16Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SearchIcon
